<template>
  <div>
		<section class="portfolio py-5" id="portfolio">
            <div class="container py-lg-5">
                <p class="paragraph">My recent Work</p>
                <h3 class="heading mb-sm-5 mb-4">Portfolio</h3>
                <div class="row">
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio1.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 1</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio2.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 2</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio3.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 3</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio4.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 4</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio5.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 5</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio1.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 6</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio2.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 7</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-6 p-0">
                        <div class="box9">
                            <img src="../../static/images/portfolio3.jpg" alt="portfolio" class="img-fluid" />
                            <div class="box-content">
                                <h3 class="title">Portfolio 8</h3>
                                <ul class="icon">
                                    <li><a href="#"><i class="fa fa-search"></i></a></li>
                                    <li><a href="#"><i class="fa fa-link"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
  </div>
</template>

<script>
export default {
  name: 'Portfolio',
  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Portfolio.vue